// 运行时环境的唯一类型事实源，业务消费者不得从构建配置读取环境字段。
export enum BizPlatform {
  GCP = 'gcp',
  SG = 'sg',
}

export const BizPlatformText = {
  [BizPlatform.GCP]: 'GCP',
  [BizPlatform.SG]: 'SG',
} as const;

export enum DeployEnv {
  LOCAL = 'local',
  TEST = 'test',
  PRE = 'pre',
  PROD = 'prod',
}

export const DeployEnvText = {
  [DeployEnv.LOCAL]: '本地环境',
  [DeployEnv.TEST]: '测试环境',
  [DeployEnv.PRE]: '预发布环境',
  [DeployEnv.PROD]: '生产环境',
} as const;

export type RuntimeConfigSource = 'server' | 'vite';

export interface AuthRuntimeProfile {
  readonly auth0ClientId: string;
}

export interface ObservabilityRuntimeProfile {
  readonly enableProductionTracking: boolean;
  /** 无法解析阶段时用 test，不跟随兜底后的 deployment.stage。 */
  readonly galileoEnvironment: 'production' | 'pre' | 'test' | null;
  readonly galileoTraceEnabled: boolean;
  readonly isDevelopmentBuild: boolean;
}

export interface RuntimeCapabilities {
  readonly devToolVisible: boolean;
}

export interface RuntimeContext {
  readonly deployment: {
    readonly platform: BizPlatform;
    readonly stage: DeployEnv;
    readonly apiHost: string;
    readonly source: 'server' | 'vite';
  };
  readonly backend: {
    readonly targetId: string;
    readonly platform: BizPlatform;
    readonly stage: DeployEnv;
    readonly apiHost: string;
    /** 是否应用了合法的 DevTool backend 覆盖。 */
    readonly overrideApplied: boolean;
  };
  readonly transport: {
    /** Vite proxy 的页面侧地址；direct 模式为空。 */
    readonly proxyBaseUrl?: string;
  };
  readonly auth: AuthRuntimeProfile;
  readonly observability: ObservabilityRuntimeProfile;
  readonly capabilities: RuntimeCapabilities;
}

export type RuntimeResolveIssueCode =
  | 'CONFIG_MISSING'
  | 'CONFIG_INVALID'
  | 'TARGET_UNKNOWN';

export interface RuntimeResolveIssue {
  readonly code: RuntimeResolveIssueCode;
  readonly detail?: string;
}

export interface RuntimeResolveResult {
  readonly context: Readonly<RuntimeContext>;
  readonly issues: readonly RuntimeResolveIssue[];
  /** pre/prod 残留，或 local/test 上代理、无法识别的 DevTool Cookie 需要删除。 */
  readonly discardOverride: boolean;
}
